// src/api/checkout/placeOrderApi.js
import axios from "axios";
import { SUBSCRIBEVOCHER } from "../index";

export const SubscribeCouponApi = (postData) => {
  return axios.post(SUBSCRIBEVOCHER, postData);
};
